import { render, staticRenderFns } from "./EMelderComponentEinstellungenMeldungsvorlagenRightElementKopfzeile.vue?vue&type=template&id=4bba39c5&scoped=true"
import script from "./EMelderComponentEinstellungenMeldungsvorlagenRightElementKopfzeile.vue?vue&type=script&lang=js"
export * from "./EMelderComponentEinstellungenMeldungsvorlagenRightElementKopfzeile.vue?vue&type=script&lang=js"
import style0 from "./EMelderComponentEinstellungenMeldungsvorlagenRightElementKopfzeile.vue?vue&type=style&index=0&id=4bba39c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bba39c5",
  null
  
)

export default component.exports